<template>
  <div>
    <v-data-table
      v-model="departamentos_selecionados"
      :headers="headers"
      :items="lista_departamentos"
      class="elevation-2 font-resp-tabela table-full-screen"
      :fixed-header="true"
      :search="search"
      show-select
      item-key="iddepartamento"
      height="calc(100vh - 243px)"
      :items-per-page="-1"
    >

    <template #top>
        <div class="d-flex align-center px-3 py-3">
          <v-icon>mdi-format-list-bulleted</v-icon>
          <span class="font-18 font-weight-medium ml-1">Lista de Departamentos</span>

          <v-spacer />

          <div class="w-400 mr-4">
            <v-text-field
              label="Pesquisar"
              clearable
              v-model="search"
              v-lazy-input:debounce="500"
              hide-details
              dense
              append-icon="mdi-magnify"
            />
          </div>

          <VincularDepartamentos
            v-model="dialogVinculaComprador"
            :departamentos_datadable_selecionada="departamentos_selecionados"
            label="Departamentos"
            outlined
            multiple
            @update:departamentos="buscarListaDeDepartamentos"
          />

        </div>
      </template>


      <template #item.action="{ item }">
        <div class="d-flex align-center">
          <v-btn
            icon
            class="ml-n1"
            title="Editar Usuário"
            @click="editarItem(item)"
            :disabled="item.ativo === 'N'"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import SegmentoAPI from '@/api/segmento'
import VincularDepartamentos from "./VincularDepartamentos.vue";
import { logout } from "@/helpers";

export default {
  name: "SecoesDepartamentos",
  components: {
    VincularDepartamentos
  },
  data() {
    return {
      dialogVinculaComprador: false,
      search: "",
      lista_departamentos: [],
      departamentos_selecionados: [],
      headers: [
        { text: "Id Departamento", align: "left", value: "iddepartamento" },
        { text: "Departamento", value: "descricao_departamento" },
        { text: "Id Comprador", value: "idcomprador" },
        { text: "Comprador", value: "nome_comprador" },
        { text: "Ações", value: "action", sortable: false, width: "100px", align: "center" },
      ]
    };
  },
  created() {
    this.buscarListaDeDepartamentos();
  },
  methods: {
    abrirDialog(item) {
      let arrayIdFornecedor = this.Helpers.arrayColumn(item, "id");
      let arrayFornecedor = [];
      arrayIdFornecedor.forEach((el) => arrayFornecedor.push(el));
      this.editedItem = arrayFornecedor;
      this.dialogMultiplos = true;
    },
    buscarListaDeDepartamentos() {
      this.lista_departamentos = [];
      this.departamentos_selecionados = [];

      const headers = this.Helpers.iniciarRequisicao()

      this.$store.dispatch(
        "loading/addRequisicao",
        SegmentoAPI.buscarDepartamentosComprador(headers)
        .then((response) => {
          localStorage.token = response.data.token;
          this.lista_departamentos = response.data.departamentos;
        })
        .catch(logout)
      );
    },
    editarItem(item) {
      this.departamentos_selecionados = [item];
      this.dialogVinculaComprador = true
    }
  }
}
</script>

<style>

</style>
